<!-- ContactCardLandingCompact.svelte -->
<script>
  const email = "administracion@icema.com.ar";
  let subject = "";
  let body = "";
  $: mailtoHref = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  const openMail = () => (window.location.href = mailtoHref);
</script>

<div class="row">
    <div class="col-2 col-lg-7 linea">
    </div>
     <div class="col-10 col-lg-5">
        <h2>Consultas</h2>
    </div>
</div>
<div class="card" role="region" aria-label="Contacto – ICEMA">
  <header class="header">
    <h2>Contacto</h2>
    <p>Escribinos y te respondemos a la brevedad.</p>
  </header>

  <div class="field">
    <label for="subject">Asunto</label>
    <input id="subject" type="text" bind:value={subject} placeholder="Consulta" maxlength="120" autocomplete="off" />
    <small class="hint">{subject.length}/120</small>
  </div>

  <div class="field">
    <label for="body">Mensaje</label>
    <textarea id="body" bind:value={body} placeholder="Hola, necesito información sobre..." rows="5" maxlength="2000" />
    <small class="hint">{body.length}/2000</small>
  </div>

  <div class="actions">
    <a class="btn" href={mailtoHref} on:click|preventDefault={openMail} aria-label="Abrir cliente de correo">✉️ Enviar correo</a>
    <a class="ghost" href={`mailto:${email}`}>Abrir sin asunto/mensaje</a>
  </div>

  <footer class="footer">
    <span class="to">Se enviará a: <strong>{email}</strong></span>
  </footer>
</div>

<style>
  :global(:root){
    --bg:#fff; --fg:#111827; --muted:#6b7280; --line:#e5e7eb;
    --brand:#2563eb; --brand-weak:#eff6ff;
  }
  .card{
    max-width:100%;margin:0 auto;background:rgba(255,255,255,0.3);
    border:1px solid var(--line);border-radius:12px;box-shadow:0 6px 18px rgba(0,0,0,.05);
    padding:.85rem;display:grid;gap:.6rem;line-height:1.25;
  }
  .header h2{margin:0;font-size:1.05rem;color:var(--fg);}
  .header p{margin:.15rem 0 0 0;color:var(--fg);font-size:.9rem;}
  .field{display:grid;gap:.35rem;}
  label{font-weight:600;color:var(--fg);font-size:.92rem;}
  input,textarea{
    width:100%;border:1px solid var(--line);border-radius:10px;
    padding:.55rem .65rem;font-size:.95rem;
    transition:border-color .15s ease, box-shadow .15s ease;
  }
  textarea{min-height:6.5rem;}
  input:focus,textarea:focus{border-color:#bfdbfe;box-shadow:0 0 0 3px var(--brand-weak);outline:0;}
  .hint{color:var(--muted);font-size:.8rem;margin-top:-.1rem;}
  .actions{display:flex;gap:.5rem;flex-wrap:wrap;align-items:center;margin-top:.1rem}
  .btn{
    padding:.55rem .8rem;border-radius:10px;background:var(--brand-weak);
    border:1px solid #dbeafe;color:var(--brand);font-weight:700;text-decoration:none;
  }
  .btn:hover{text-decoration:underline;}
  .ghost{color:var(--muted);text-decoration:none;font-weight:600;font-size:.9rem;}
  .ghost:hover{text-decoration:underline;}
  .footer{border-top:1px dashed var(--line);padding-top:.45rem;color:var(--fg);font-size:.85rem;}
  @media (max-width:520px){.card{padding:.7rem;gap:.5rem}}
</style>
